'use strict';

import {
    GENERIC_ERROR_MESSAGE
} from './AppConstants';

import feedbackMessagesStore from './FeedbackMessagesStore';
import Level from './FeedbackMessagesLevel';

/**
 * A utility to deal with exception handling.
 */
class ExceptionUtils {

    constructor(appStore) {
        this.appStore = appStore;
    }

    /**
     * Common code for exception handling in AJAX calls.
     *
     * @param error An error/exception most likely originating from one of the FetchUtils.process* methods.
     * @param operationName Used if there is need to clear the error messages in case of a successful retry
     * @param showFeedback Used to conditionally show the error in the feedback messages, defaults to true
     */
    handleException(error, operationName, showFeedback = true) {
        /**
         * Check for an exceptionCode property to determine if the message needs to be passed along.
         * Add feedback message if it's an error we generated in our controllers. Otherwise, set a generic message and
         * attempt to tease some additional info out of the error and send it to the backend.
         */
        let errorText;

        if (error.exceptionCode) {
            errorText = error.message;
            if (!error.expected && showFeedback) {
                feedbackMessagesStore.addMessage({level: Level.ERROR, text: errorText, operation: operationName});
            }

            if (this.appStore.isDevMode()) {
                // Output some debugging info in dev mode.
                console.error(`Error response received performing operation [${operationName}] , response: [${error.exceptionCode}][${errorText}].`);
            }
        } else {
            if (showFeedback) {
                // Just add the generic message to feedback messages.
                feedbackMessagesStore.addMessage({level: Level.ERROR, text: GENERIC_ERROR_MESSAGE});
            }
            errorText = error.toString();
        }

        // Finally, log and forward the error message to the backend so that it gets counted in metrics and appears in the logs.
        this.appStore.getLogger().error(errorText, {operationName: operationName, stack: error.stack}, error.expected);
    }
}

export default ExceptionUtils;